import { render, staticRenderFns } from "./GroupInTwoColumns.vue?vue&type=template&id=39c9845f&scoped=true&functional=true&"
import script from "./GroupInTwoColumns.vue?vue&type=script&lang=js&"
export * from "./GroupInTwoColumns.vue?vue&type=script&lang=js&"
import style0 from "./GroupInTwoColumns.vue?vue&type=style&index=0&id=39c9845f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "39c9845f",
  null
  
)

export default component.exports